export default class Line {

	constructor(nearX, nearY, farX, farY) {
		this.nearX = nearX;
		this.nearY = nearY;
		this.farX = farX;
		this.farY = farY;
		this.deltaX = farX - nearX;
		this.deltaY = farY - nearY;
	}
	clone() {
		return new Line(this.nearX, this.nearY, this.farX, this.farY);
	}
	setNearPoint(nearX, nearY) {
		this.nearX = nearX;
		this.nearY = nearY;
		this.deltaX = this.farX - this.nearX;
		this.deltaY = this.farY - this.nearY;
	}
	setFarPoint(farX, farY) {
		this.farX = farX;
		this.farY = farY;
		this.deltaX = this.farX - this.nearX;
		this.deltaY = this.farY - this.nearY;
	}
	isBelow(x, y) {
		return this.calculateRelativeSlope(x, y) > 0;
	}
	isBelowOrCollinear(x, y) {
		return this.calculateRelativeSlope(x, y) >= 0;
	}
	isAbove(x, y) {
		return this.calculateRelativeSlope(x, y) < 0;
	}
	isAboveOrCollinear(x, y) {
		return this.calculateRelativeSlope(x, y) <= 0;
	}
	isCollinear(x, y) {
		return this.calculateRelativeSlope(x, y) === 0;
	}
	isLineCollinear(line) {
		return this.isCollinear(line.nearX, line.nearY) && this.isCollinear(line.farX, line.farY);
	}
	calculateRelativeSlope(x, y) {
		return this.deltaY * (this.farX - x) - this.deltaX * (this.farY - y);
	}
}